import i18n from "../i18n";

var selected_language = localStorage.getItem("language");
if (selected_language == '') {
    selected_language = 'en'
    i18n.locale = "en"
}
if (selected_language == "fa") {
    i18n.locale = "fa"
}
export default [
    {
        _name: 'CSidebarNav',
        redirect: '/dashboard/',
        _children: [
            {
                _name: 'CSidebarNavItem',
                name: "پیشخوان",
                to: "/dashboard",
                icon: "navDashboard",
            },
            {
                _name: 'CSidebarNavDropdown',
                name: "فروشگاه",
                route: "/dashboard/orders",
                icon: "navOrders",
                items: [
                    { name: "سفارش‌ها", to: "/dashboard/orders/list", role: "order_list", badgeKey: "orders" },
                    { name: "کدهای تخفیف", to: "/dashboard/settings/off_coupons", role: "off_coupons" },
                    { name: "سبدهای خرید رهاشده", to: "/dashboard/orders/user_carts", role: "add_order" },
                    { name: "اطلاع از موجود شدن", to: "/dashboard/orders/user_stock_alert", role: "add_order" },
                    { name: "تنظیمات فروشگاه", to: "/dashboard/settings/shop", roles: ["shipping", "gateways", "add_order_status"] },
                    { name: "همه محصولات", to: "/dashboard/products/list", role: "add_product" },
                    { name: "افزودن محصول", to: "/dashboard/products/create", role: "add_product" },
                    { name: "دسته‌ها", to: "/dashboard/products/category/0", role: "product_category" },
                    { name: "برچسب‌ها", to: "/dashboard/products/tags", role: "product_tags" },
                    { name: "ویژگی‌ها (الگوی مشخصات)", to: "/dashboard/products/property-templates", role: "template_property" },
                    { name: "ویژگی‌های اضافی", to: "/dashboard/products/additional-options", role: "template_property" },
                    { name: "خصوصیات (تنوع‌ها)", to: "/dashboard/products/product-bundles", role: "product_bundles" },
                    { name: "برندها", to: "/dashboard/products/brands", role: "product_brands" },
                    { name: "درون‌ریزی از دیجی‌کالا", to: "/dashboard/products/digikala-bulk", role: "add_product" }
                ]
            },
            {
                _name: 'CSidebarNavDropdown',
                name: "محتوا",
                route: "/dashboard/news",
                icon: "navBlog",
                items: [
                    { name: "همه نوشته‌ها", to: "/dashboard/news/all-news", role: "blog_post" },
                    { name: "کمپین‌های محتوا", to: "/dashboard/news/campaigns", roles: ["blog_post", "basic_settings"] },
                    { name: "افزودن نوشته", to: "/dashboard/news/add-news", role: "blog_post" },
                    { name: "دسته‌های نوشته", to: "/dashboard/news/categories/0", role: "blog_category" },
                    { name: "برچسب‌های نوشته", to: "/dashboard/news/tags", role: "blog_tags" },
                    { name: "همه برگه‌ها", to: "/dashboard/pages/list", role: "add_page" },
                    { name: "افزودن برگه", to: "/dashboard/pages/add", role: "add_page" },
                    { name: "کتابخانه رسانه", to: "/dashboard/media" }
                ]
            },
            {
                _name: 'CSidebarNavDropdown',
                name: "دیدگاه‌ها",
                route: "/dashboard/news/comments",
                icon: "navComments",
                items: [
                    { name: "دیدگاه نوشته‌ها", to: "/dashboard/news/comments", role: "blog_comments", badgeKey: "comments:post" },
                    { name: "دیدگاه محصولات", to: "/dashboard/products/comments", role: "product_comments", badgeKey: "comments:product" }
                ]
            },
            {
                _name: 'CSidebarNavItem',
                name: "فرم‌ها",
                to: "/dashboard/forms/list",
                icon: "navForms",
                role: "add_page",
                badgeKey: "forms",
            },
            {
                _name: 'CSidebarNavDropdown',
                name: "کاربران",
                route: "/dashboard/users",
                icon: "navUsers",
                items: [
                    { name: "مدیران", to: "/dashboard/users/admins", role: "admins" },
                    { name: "مشتریان", to: "/dashboard/orders/customers", role: "add_order" },
                    { name: "کاربران سایت", to: "/dashboard/users/customers", role: "admins", badgeKey: "users" },
                    { name: "نقش‌ها و دسترسی‌ها", to: "/dashboard/users/permission-groups", role: "permission_groups" },
                    { name: "پروفایل من", to: "/dashboard/users/profile" }
                ]
            },
            {
                _name: 'CSidebarNavDropdown',
                name: "گزارش‌ها",
                route: "/dashboard/reports",
                icon: "navReports",
                items: [
                    { name: "آمار بازدید", to: "/dashboard/reports/analytics", role: "add_page" },
                    { name: "فروش زمانی", to: "/dashboard/reports/report-date", role: "add_product" },
                    { name: "فروش مناطق", to: "/dashboard/reports/province", role: "add_product" },
                    { name: "فروش کالاها", to: "/dashboard/reports/products", role: "add_product" },
                    { name: "فروش ماهانه", to: "/dashboard/reports/monthly_sale_products", role: "add_product" },
                    { name: "پرداختی‌ها", to: "/dashboard/reports/payments", role: "add_product" },
                    { name: "موجودی", to: "/dashboard/reports/stocks", role: "add_product" }
                ]
            },
            {
                _name: 'CSidebarNavDropdown',
                name: "نمایش",
                route: "/dashboard/display",
                icon: "navDisplay",
                items: [
                    { name: "صفحه اصلی (چیدمان)", to: "/dashboard/settings/homepage", role: "ui_settings" },
                    { name: "سفارشی‌سازی", to: "/dashboard/display/template_settings", role: "template_settings" },
                    { name: "فهرست‌ها", to: "/dashboard/display/menus/0", role: "ui_menu" },
                    { name: "اسلایدرها", to: "/dashboard/display/sliders", role: "ui_slider" },
                    { name: "بنر آفر", to: "/dashboard/display/offer-banner", role: "ui_menu" },
                    { name: "امتیاز", to: "/dashboard/display/features", role: "ui_settings" },
                    { name: "دکمه تماس شناور", to: "/dashboard/display/floating-contact", role: "ui_settings" },
                    { name: "تنظیمات کش", to: "/dashboard/display/cache", role: "ui_settings" },
                    { name: "محتوای قالب (صفحه اصلی و فوتر)", to: "/dashboard/display/theme-content", role: "ui_settings", themeOnly: true }
                ]
            },
            {
                _name: 'CSidebarNavDropdown',
                name: "ابزارها",
                route: "/dashboard/settings/redirect",
                icon: "navTools",
                items: [
                    { name: "ریدایرکت‌ها", to: "/dashboard/settings/redirect", role: "redirect" },
                    { name: "سورس‌های ورودی", to: "/dashboard/settings/income_source_list", role: "redirect" },
                    { name: "پاپ‌آپ‌ها", to: "/dashboard/popups/list", role: "ui_settings" },
                    { name: "بهینه‌سازی عکس‌ها", to: "/dashboard/settings/image-webp", role: "ui_settings" },
                    { name: "هوش مصنوعی لینک‌ساز", to: "/dashboard/settings/ai-linker", role: "ui_settings" }
                ]
            },
            {
                _name: 'CSidebarNavDropdown',
                name: "تنظیمات",
                route: "/dashboard/settings",
                icon: "navSettings",
                items: [
                    { name: "عمومی", to: "/dashboard/settings/main-setting", role: "basic_settings" },
                    { name: "هوش مصنوعی", to: "/dashboard/settings/ai", role: "basic_settings" },
                    { name: "پیامک و بله", to: "/dashboard/settings/messaging", role: "basic_settings" },
                ]
            },
        ]
    }
]
